import { render, staticRenderFns } from "./IntegralSuccess.vue?vue&type=template&id=550b2e02&scoped=true&"
import script from "./IntegralSuccess.vue?vue&type=script&lang=ts&"
export * from "./IntegralSuccess.vue?vue&type=script&lang=ts&"
import style0 from "./IntegralSuccess.vue?vue&type=style&index=0&id=550b2e02&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "550b2e02",
  null
  
)

export default component.exports